"use client";

import 'bootstrap/dist/css/bootstrap.css';
import "./globals.css";
import Link from 'next/link'


export default async function NotFound() {

  return (
    <div style={{
      fontFamily: 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
      height: '100vh',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <div>
        <img alt="logo" className="footerLogo" src="/images/whitelogo.svg"></img>
        <style>{`body{color:#000;background:#fff;margin:0}.next-error-h1{border-right:1px solid rgba(0,0,0,.3)}@media (prefers-color-scheme:dark){body{color:#fff;background:#000}.next-error-h1{border-right:1px solid rgba(255,255,255,.3)}}`}</style>
        <h1 className="next-error-h1" style={{
          display: 'inline-block',
          margin: '0 20px 0 0',
          padding: '0 23px 0 0',
          fontSize: '24px',
          fontWeight: 500,
          verticalAlign: 'top',
          lineHeight: '49px'
        }}>404</h1>
        <div style={{ display: 'inline-block' }}>
          <h2 style={{
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '49px',
            margin: 0
          }}>This page could not be found.</h2>
    
        </div>
        <Link className="button-small white-small w-inline-block" href="/">
            <div className="button-label">
              Home
            </div>
            <img src="/images/arrow-dark-402x.svg" alt="" className="button-arrow-3" />
          </Link>
      </div>
    </div>

  );
}
